////////LIBRARY/////////
import update from 'immutability-helper'
///////COMPONENTS///////
import extendUpdate from '../../helpers/extendUpdate'
import ActionsTypes from '../../constants/ActionsTypes'

extendUpdate(update)

const initKioskManager = {
	[ActionsTypes.RESET_DATA_INIT_KIOSK_BUSINESS]: (state) => {
		return update(state, {
			initKioskBusinessManager: {
				items: {
					$set: [],
				},
			},
		})
	},

	[ActionsTypes.GET_INIT_KIOSKS_BUSINESS]: (state) =>
		update(state, {
			initKioskBusinessManager: {
				isLoading: {
					$set: true,
				},
				error: {
					$set: false,
				},
				items: {
					$set: [],
				},
			},
			columns: {
				isSearchfieldUpdated: {
					$set: false,
				},
			},
		}),
	[ActionsTypes.GET_INIT_KIOSKS_BUSINESS_SUCCESS]: (state, payload) => {
		const paging = {
			totalElements: payload.data.headerContent.contentPagined.totalElements,
			totalPages: payload.data.headerContent.contentPagined.totalPages,
		}

		return update(state, {
			initKioskBusinessManager: {
				isLoading: {
					$set: false,
				},
				error: {
					$set: false,
				},
				items: {
					$set: payload.data.headerContent.contentPagined.content,
				},
				paging: {
					$set: paging,
				},
				header: {
					$set: payload.data.headerParam.filters,
				},
			},
		})
	},
	[ActionsTypes.GET_INIT_KIOSKS_BUSINESS_FAILURE]: (state, payload) => {
		return update(state, {
			initKioskBusinessManager: {
				isLoading: {
					$set: false,
				},
				error: {
					$set: payload.error,
				},
			},
		})
	},
	[ActionsTypes.GET_INIT_KIOSKS_CUSTOMER]: (state) =>
		update(state, {
			initKioskCustomerManager: {
				isLoading: {
					$set: true,
				},
				error: {
					$set: false,
				},
				items: {
					$set: [],
				},
			},
			columns: {
				isSearchfieldUpdated: {
					$set: false,
				},
				currentDir: {
					$set: '',
				},
				currentColumn: {
					$set: '',
				},
			},
		}),
	[ActionsTypes.GET_INIT_KIOSKS_CUSTOMER_SUCCESS]: (state, payload) => {
		const paging = {
			totalElements: payload.data.headerContent.contentPagined.totalElements,
			totalPages: payload.data.headerContent.contentPagined.totalPages,
		}

		return update(state, {
			initKioskCustomerManager: {
				isLoading: {
					$set: false,
				},
				error: {
					$set: false,
				},
				items: {
					$set: payload.data.headerContent.contentPagined.content,
				},
				paging: {
					$set: paging,
				},
				header: {
					$set: payload.data.headerParam.filters,
				},
			},
		})
	},
	[ActionsTypes.GET_INIT_KIOSKS_CUSTOMER_FAILURE]: (state, payload) => {
		return update(state, {
			initKioskCustomerManager: {
				isLoading: {
					$set: false,
				},
				error: {
					$set: payload.error,
				},
			},
		})
	},
	[ActionsTypes.SET_REQUEST_CUSTOMER_PARAMS]: (state, payload) => {
		return update(state, {
			initKioskCreation: {
				statusId: {
					$set: payload.statusId,
				},
				requestId: {
					$set: payload.id,
				},
				forceReadOnly: {
					$set: payload.readOnly,
				},
			},
		})
	},
	[ActionsTypes.SET_REQUEST_BUSINESS_PARAMS]: (state, payload) => {
		return update(state, {
			initKioskCreation: {
				statusId: {
					$set: payload.statusId,
				},
				requestId: {
					$set: payload.id,
				},
				forceReadOnly: {
					$set: payload.readOnly,
				},
			},
		})
	},
	[ActionsTypes.PUT_KIOSK_BUILD]: (state) =>
		update(state, {
			initKioskBusinessManager: {
				isLoading: {
					$set: true,
				},
				isKioskUpdated: {
					$set: false,
				},
			},
		}),
	[ActionsTypes.PUT_KIOSK_BUILD_SUCCESS]: (state, _payload) => {
		return update(state, {
			initKioskBusinessManager: {
				isLoading: {
					$set: false,
				},
				isKioskUpdated: {
					$set: true,
				},
			},
		})
	},
	[ActionsTypes.PUT_KIOSK_BUILD_FAILURE]: (state, payload) => {
		return update(state, {
			initKioskBusinessManager: {
				isLoading: {
					$set: false,
				},
				items: {
					$set: payload.error,
				},
			},
		})
	},
	[ActionsTypes.VIEW_PRODUCTION_SHEET]: (state) =>
		update(state, {
			initKioskBusinessManager: {
				isLoading: {
					$set: true,
				},
			},
		}),
	[ActionsTypes.VIEW_PRODUCTION_SHEET_SUCCESS]: (state) => {
		return update(state, {
			initKioskBusinessManager: {
				isLoading: {
					$set: false,
				},
			},
		})
	},
	[ActionsTypes.VIEW_PRODUCTION_SHEET_FAILURE]: (state) => {
		return update(state, {
			initKioskBusinessManager: {
				isLoading: {
					$set: false,
				},
			},
		})
	},
}

export default initKioskManager
